import { routes } from '@routes';

import { link, RouteLink } from '@utils/link';

import { IconType } from '@atoms';

type ErrorPageBox = {
  iconType: IconType;
  titleId: string;
  subtitleId: string;
  linkText: string;
  pageLink: RouteLink;
};

export type ErrorPageBoxProps = ErrorPageBox;

export const errorPageBoxes: ErrorPageBox[] = [
  {
    iconType: 'property-valuation',
    titleId: 'error_page.box_atlas.title',
    subtitleId: 'error_page.box_atlas.subtitle',
    linkText: 'error_page.box_atlas.link_text',
    pageLink: link(routes.atlas),
  },

  {
    iconType: 'news-blog',
    titleId: 'error_page.box_news_blog.title',
    subtitleId: 'error_page.box_news_blog.subtitle',
    linkText: 'error_page.box_news_blog.link_text',
    pageLink: link(routes.blogHomepage),
  },

  {
    iconType: 'reas-story',
    titleId: 'error_page.box_reas_story.title',
    subtitleId: 'error_page.box_reas_story.subtitle',
    linkText: 'error_page.box_reas_story.link_text',
    pageLink: link(routes.page, { path: 'o-nas' }),
  },
];
